import { OnlineOrderingStore } from 'kiolyn-api';
import { decorate, observable } from 'mobx';
import { useLocalStore } from 'mobx-react-lite';
import React, { createContext, FC, ReactElement, useContext } from 'react';
import { isNullOrUndefined } from 'util';
import { ViewState } from '../domain/models/ViewState';
import IOnlineOrderingRepository from '../domain/repositories/IOnlineOrderingRepository';

export class StoresStore {
  viewState: ViewState = ViewState.LOADING;
  stores: OnlineOrderingStore[] = [];
  storeRepository?: IOnlineOrderingRepository;

  constructor(storeRepository?: IOnlineOrderingRepository) {
    this.storeRepository = storeRepository;
  }

  public async reload(): Promise<void> {
    if (isNullOrUndefined(this.storeRepository)) {
      return;
    }
    this.viewState = ViewState.LOADING;
    try {
      this.stores = await this.storeRepository.listStore();
      this.viewState = ViewState.OK;
    } catch (err) {
      console.error(err);
      this.viewState = ViewState.ERROR;
    }
  }
}

decorate(StoresStore, {
  viewState: observable,
  stores: observable
});

interface StoresProviderProps {
  children: ReactElement;
  storesRepository: IOnlineOrderingRepository;
}

export const StoresProvider: FC<StoresProviderProps> = ({
  children,
  storesRepository
}: StoresProviderProps) => {
  const store = useLocalStore(() => new StoresStore(storesRepository));
  store.reload();
  return (
    <StoresContext.Provider value={store}>{children}</StoresContext.Provider>
  );
};

export const StoresContext = createContext(new StoresStore());
export const useStores = () => useContext(StoresContext);
